import { z } from 'zod'

import type { SignupData } from '@scalar-org/entities/project'

import type { RequestService } from '../request'

export function signupApiFactory(requestService: RequestService) {
  /** Save session data on use signup */
  async function saveData(signupData: Omit<SignupData, 'uid'>) {
    return await requestService.request({
      url: 'core/signup-data',
      method: 'post',
      data: signupData,
      schema: z.object({ dataUid: z.string() }),
    })
  }

  return {
    saveData,
  }
}
